import maplibregl from 'maplibre-gl';

let loading;
// MapLibre 5.6 requires the ICU plugin for Arabic shaping and bidi ordering.
// Serve the pinned distribution locally, without a runtime CDN dependency.
export function configureHomeMapRTL() {
  if (!loading) {
    const status = maplibregl.getRTLTextPluginStatus();
    if (status === 'loaded') return Promise.resolve();
    loading = maplibregl.setRTLTextPlugin(
      `${process.env.PUBLIC_URL || ''}/vendor/mapbox-gl-rtl-text/mapbox-gl-rtl-text-0.3.0.js`, false
    );
  }
  return loading;
}
